module.exports = __webpack_public_path__ + "img/project6_1.png.450312db.webp";